import React from 'react';
import PropTypes from 'prop-types';

export class ToggleSwitch extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      checked: false
    };

    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount () {
    const { defaultChecked } = this.props;
    this.setState({
      checked: defaultChecked
    });
  }

  componentDidUpdate (prevProps) {
    if (prevProps.defaultChecked !== this.props.defaultChecked) {
      this.setState({
        checked: this.props.defaultChecked
      });
    }
  }

  handleChange (event) {
    const selectedValue = event.target.checked;
    this.setState({
      checked: selectedValue
    });

    if (this.props.changeCallback) {
      this.props.changeCallback(selectedValue);
    }
  }

  render () {
    const { checked } = this.state;
    const { onText, offText, inputID } = this.props;
    return (
      <div className="toggle-switch">
        <label className="switch" id={inputID}>
          <input
            type="checkbox"
            onChange={this.handleChange}
            checked={checked}
          />
          <div className="slider round" />
        </label>
        <div className="margin-md-left">
          { checked ?
            <span>{onText}</span> :
            <span>{offText}</span>
          }
        </div>
      </div>
    );
  }
}

ToggleSwitch.defaultProps = {
  onText: '',
  offText: '',
  inputID: 'toggle-switch'
};

ToggleSwitch.propTypes = {
  changeCallback: PropTypes.func,
  defaultChecked: PropTypes.bool,
  onText: PropTypes.string,
  offText: PropTypes.string,
  inputID: PropTypes.string
};
